export const BLUEPRINTS_SUBMENU_WIDTH = 240;
export const BOTTOM_BAR_HEIGHT = 40;

// TODO: Update constant to 400px as defined in the design (also consider 24px of padding for x-axis)
export const DETAILS_PANEL_WIDTH = 600;
export const NODE_DETAILS_PANEL_WIDTH = 448;
export const REVIEW_CHANGES_PANEL_WIDTH = 400;

export const GRID_PREVIEW_HEADER_HEIGHT = 48;

export const CARD_CONTENT_MIN_HEIGHT = 32;
export const SIDEBAR_WIDTH_CLOSED = 56;
export const SIDEBAR_WIDTH_OPEN = 296;
export const TOP_BAR_HEIGHT = 48;
export const CONTENT_PAGE_HEIGHT = `calc(100% - ${TOP_BAR_HEIGHT}px)`;

/** Width of the in-page secondary navigation rail. Fixed at every breakpoint by design. */
export const PAGE_SIDE_NAV_WIDTH = 280;

export const DEBOUNCE_TIME = 250;
